import { QrCodeIcon } from "@phosphor-icons/react/dist/csr/QrCode";
import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@volca/ui/components/ui/line-clamped-tooltip";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { getCustomerNameOrPhone } from "@/customer/utils";
import { IReferral } from "@/referrals/referral";

interface ContentProps {
  nameOrPhone: string;
  attributedTo?: string | null;
}

const Content = ({ nameOrPhone, attributedTo }: ContentProps) => (
  <Stack align="start" justify="center" gap={0} className="h-full w-full">
    <LineClampedTooltip>{nameOrPhone}</LineClampedTooltip>
    {attributedTo && (
      <Tooltip>
        <TooltipTrigger
          render={<Stack align="start" direction="row" gap={1} />}
        >
          <QrCodeIcon className="h-4 w-4 min-w-4 text-subtle" />
          <Text tone="muted" className="line-clamp-1">
            {attributedTo}
          </Text>
        </TooltipTrigger>
        <TooltipContent className="max-w-lg">
          <b>{attributedTo}</b> signed up the advocate that sent this referral
        </TooltipContent>
      </Tooltip>
    )}
  </Stack>
);

const AdvocateCol = (): ColumnDef<IReferral> => ({
  header: "Advocate",
  accessorFn: (row) => getCustomerNameOrPhone(row.advocate),
  cell: ({ row, getValue }) => {
    const nameOrPhone = getValue() as string;
    const attributedTo =
      row.original.advocate.signup_source?.display_identification;

    return <Content nameOrPhone={nameOrPhone} attributedTo={attributedTo} />;
  },
});

export default AdvocateCol;
